(ns frontend.views.disclosure
  "Behaviour a server-rendered `<details>` disclosure has no native equivalent
  for: dismissing when the interaction leaves it."
  (:require
   [common.util  :as u]
   [shadow.graft :as graft]))

(defn- dismiss-on-leave
  "Closes the disclosure when the interaction leaves it — a click outside, Tab out
  of it, or Escape, which hands focus back to its summary."
  [^js details]
  (.addEventListener js/document "click"
                     (fn [^js event]
                       (when-not (.contains details (.-target event))
                         (set! (.-open details) false))))
  ;; keyed on Tab rather than on focusout, which also fires when a click inside
  ;; the disclosure lands on something unfocusable and would close it from within
  (.addEventListener details "keydown"
                     (fn [^js event]
                       (when (= "Tab" (.-key event))
                         (js/setTimeout
                          (fn []
                            (when-not (.contains details (.-activeElement js/document))
                              (set! (.-open details) false)))
                          0))))
  (.addEventListener js/document "keydown"
                     (fn [^js event]
                       (when (and (= "Escape" (.-key event))
                                  (.-open details))
                         (let [focus-inside? (.contains details (.-activeElement js/document))]
                           (set! (.-open details) false)
                           ;; Escape must not strand focus on a disclosure that is gone
                           (when focus-inside?
                             (.focus (.querySelector details "summary"))))))))

(defmethod graft/scion (u/->scion-id :frontend.views.disclosure/dismiss-on-leave)
  [_params details]
  (dismiss-on-leave details))
